module.exports = __webpack_public_path__ + "static/images/favicon.bc5cde62b51b65eb2064da1d5f7a327e.png";